export default __webpack_public_path__ + "static/media/calendar.33a434db.svg";